import { useTranslation } from "react-i18next";

import { CsvDetailsModal } from "#shared/view/components/CsvDetailsModal";
import { List } from "#shared/view/components/List";
import { Text } from "#shared/view/components/Text";

type Props = {
  opened: boolean;
  close: () => void;
};

export const SurfaceTreatmentsCsvDetailsModal = ({ close, opened }: Props) => {
  const { t } = useTranslation();

  return (
    <CsvDetailsModal opened={opened} close={close}>
      <List>
        <List.Item>
          <Text>
            <Text span fw={700}>
              {t("settings.surfaceTreatments.csvHelp.descriptionLabel")}
              {": "}
            </Text>
            {t("settings.surfaceTreatments.csvHelp.descriptionHelp")}
          </Text>
        </List.Item>
        <List.Item>
          <Text>
            <Text span fw={700}>
              {t("settings.surfaceTreatments.csvHelp.methodLabel")}
              {": "}
            </Text>
            {t("settings.surfaceTreatments.csvHelp.methodHelp")}
          </Text>
          <List withPadding>
            <List.Item>{t("settings.surfaceTreatments.csvHelp.methodM2")}</List.Item>
            <List.Item>{t("settings.surfaceTreatments.csvHelp.methodM3")}</List.Item>
            <List.Item>{t("settings.surfaceTreatments.csvHelp.methodKg")}</List.Item>
            <List.Item>{t("settings.surfaceTreatments.csvHelp.methodFixed")}</List.Item>
            <List.Item>{t("settings.surfaceTreatments.csvHelp.methodFormula")}</List.Item>
          </List>
        </List.Item>
        <List.Item>
          <Text>
            <Text span fw={700}>
              {t("settings.surfaceTreatments.csvHelp.priceLabel")}
              {": "}
            </Text>
            {t("settings.surfaceTreatments.csvHelp.priceHelp")}
          </Text>
        </List.Item>
        <List.Item>
          <Text>
            <Text span fw={700}>
              {t("settings.surfaceTreatments.csvHelp.formulaLabel")}
              {": "}
            </Text>
            {t("settings.surfaceTreatments.csvHelp.formulaHelp")}
          </Text>
        </List.Item>
        <List.Item>
          <Text>
            <Text span fw={700}>
              {t("settings.surfaceTreatments.csvHelp.typeLabel")}
              {": "}
            </Text>
            {t("settings.surfaceTreatments.csvHelp.typeHelp")}
          </Text>
          <List withPadding>
            <List.Item>{t("settings.surfaceTreatments.csvHelp.typeInhouse")}</List.Item>
            <List.Item>{t("settings.surfaceTreatments.csvHelp.typeOutsourcing")}</List.Item>
          </List>
        </List.Item>
      </List>
    </CsvDetailsModal>
  );
};
